import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const WebPushSend = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M14.8125 20.4375H9.1875L9.75 17.0625H14.25L14.8125 20.4375Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 20.4375H16.5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5625 14.0625H20.4375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1875 3.5625H5.8125C4.56986 3.5625 3.5625 4.56986 3.5625 5.8125V14.8125C3.5625 16.0551 4.56986 17.0625 5.8125 17.0625H18.1875C19.4301 17.0625 20.4375 16.0551 20.4375 14.8125V5.8125C20.4375 4.56986 19.4301 3.5625 18.1875 3.5625Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
